// extracted by mini-css-extract-plugin
export default {"accountSecuritySettings":"setting_accountSecuritySettings__DTOLp","submitButton":"setting_submitButton__1Q+6k","inputIcon":"setting_inputIcon__jopxa"};